<template>
    <a href="https://www.amadiamond.com/" target="_blank" v-if="false && !isAma && credential && credential.apiEncryptedUser && retailPerc === 1">
        <div class="ama-link">
            <p class="text">{{ $t('discover_collection') }}</p>
            <img class="img" src="../assets/ama-link.png" alt />
        </div>
    </a>
</template>

<script>
import { mapState } from 'vuex';

export default {
    computed: mapState({
        isAma: (state) => state.config.isAma,
        credential: (state) => state.config.credential,
        retailPerc: (state) => state.detail.retailPerc
    }),
    data() {
        return {

        }
    },
}
</script>

<style lang="scss" scoped>

a {
    color: black;
    text-decoration: none !important;

    &:hover {
        text-decoration: none;
        color: black;
    }
}

.ama-link {
    position: fixed;
    top: 20px;
    right: 0px;
    background-color: white;
    border-radius: 5px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
    z-index: 1000;
}

.text {
    font-size: 12px;
    text-align: center;
    width: 170px;
    margin-top: 10px;
    text-decoration: underline;
    font-family: var(--font-family-reckless-italic);
}

.img {
    position: absolute;
    top: 0;
    right: 0;
    z-index: -1;
    border-radius: 2%;
}
</style>